import Icon from "components/Icon"
import Link from "next/link"

export default function OurDifferenceGraphic({ blok }) {
  return (
    <section className="px-5 py-8 mb-4 lg:py-16 bg-highlight-tint">
      <div className="max-w-4xl mx-auto prose-h2:pb-8 prose-h2:lg:pb-16">
        <h2 className="lg:text-center text-primary">{blok?.heading}</h2>
        <div className="lg:columns-2 gap-x-24">
          {blok?.icons?.map(({ icon, label, anchor, _uid }) => (
            <div key={_uid} className="mb-12 flex gap-3 items-center prose-h3:pb-0">
              <div>
                <Icon icon={icon} className="w-11" />
              </div>
              <Link href={`#${anchor}`}>
                <h3 className="text-primary font-primary text-base hover:underline">{label}</h3>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
